'use strict';

var definitions = require('./definitions.cjs');

function loadFeatures(features) {
    for (const key in features) {
        definitions.featureDefinitions[key] = {
            ...definitions.featureDefinitions[key],
            ...features[key],
        };
    }
}

exports.loadFeatures = loadFeatures;
//# sourceMappingURL=load-features.cjs.map
